import './style.scss'

import React, { useCallback, useEffect, useRef, useState } from 'react'

import { formEvent } from '../Form/Form'
import t from '../../helpers/i18n'
import { useDropzone } from 'react-dropzone'

const getImageData = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsArrayBuffer(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = reject
})

const getImagesMetadata = (images) => {
  return images.map((image) =>
    image.id
      ? {
          id: image.id
        }
      : {
          name: image.file.name,
          type: image.file.type,
          size: image.file.size,
          get: async () => getImageData(image.file)
        }
  )
}

const GaleryUploader = ({ name, label, sources, required }) => {
  const [images, setImages] = useState(sources || [])
  const element = useRef()

  const propagateValue = useCallback(() => {
    if (name) {
      element.current.dispatchEvent(
        formEvent({
          action: 'PENDING',
          name,
          value: getImagesMetadata(images)
        })
      )
    }
  }, [name, images])

  const onDrop = useCallback(
    (acceptedFiles) => {
      const files = acceptedFiles.map((file) => ({
        file: file,
        image: URL.createObjectURL(file)
      }))
      setImages([...images, ...files])
    },
    [images]
  )

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'image/*'
  })

  useEffect(propagateValue, [propagateValue])

  useEffect(() => {
    if (name) {
      element.current.dispatchEvent(
        formEvent({
          action: 'REQUIRED',
          name,
          required
        })
      )
    }
  }, [name, required])

  useEffect(() => {
    const _element = element.current
    return () => {
      if (name) {
        _element.dispatchEvent(
          formEvent({
            action: 'REMOVE',
            name
          })
        )
      }
    }
  }, [name])

  return (
    <div className="galery-uploader" ref={element}>
      <div className="-label text-label">{label}</div>
      <div className="-previews">
        {images.map((source, index) =>
          <div key={index} className='-preview'><img src={source.source ? source.source : source.image} alt="" /></div>
        )}
      </div>
      <div {...getRootProps()} className='-dropzone'>
        <input {...getInputProps()} />
        <div className='-hint'>
          {t('Drag_images_to_this_area_or_click_on')}{' '}
          <button>{t('Upload_images')}</button>
        </div>
      </div>
    </div>
  )
}

export default GaleryUploader
